import classNames from 'classnames';
import * as React from 'react';

import css from './GoogleMap.module.scss';

interface Maps {
  address_city?: string;
  href?: string;
  img_src?: string;
  latitude?: string;
  longitude?: string;
}

interface Props {
  displayName: string;
  mapData: Maps;
}

const GoogleMap = ({ displayName, mapData }: Props) => {
  const classes = classNames(css.GoogleMap);

  return (
    <div className={classes}>
      {mapData.href ? (
        <address className={css.GoogleMap__Address}>
          <a href={mapData.href}>{mapData.address_city}</a>
        </address>
      ) : (
        <address className={css.GoogleMap__Address}>
          {mapData.address_city}
        </address>
      )}
      {mapData.img_src && (
        <figure className={css.GoogleMap__Image}>
          <img src={mapData.img_src} alt={displayName} />
        </figure>
      )}
    </div>
  );
};

export default GoogleMap;
